import { useTranslation } from 'react-i18next';
import { formatUtcToLocalTime } from '@/utils/dateUtils';

interface StampTimeProps {
  event: { timestamp?: string; effectiveTimestamp?: string } | null | undefined;
  className?: string;
}

/**
 * The counted time of a time clock stamp (FACF-87/149: not before the work count start, „Zählbeginn“). When the stamp itself
 * differs — e.g. clocked in at 05:30 — the raw time follows struck through, so the hours shown
 * next to it can be traced back.
 */
export function StampTime({ event, className = '' }: StampTimeProps) {
  const { t } = useTranslation('timeclock');
  const raw = formatUtcToLocalTime(event?.timestamp);
  const counted = event?.effectiveTimestamp ? formatUtcToLocalTime(event.effectiveTimestamp) : raw;

  if (counted === raw) {
    return <span className={`tabular-nums ${className}`}>{counted}</span>;
  }
  return (
    <span
      className={`inline-flex items-baseline gap-1 tabular-nums ${className}`}
      title={t('events.tooltipEarly', { actual: raw, effective: counted })}
    >
      <span className="line-through opacity-60">{raw}</span>
      <span>{counted}</span>
    </span>
  );
}
